<div *ngIf="title" mat-dialog-title>
    {{ title }}
</div>
<mat-dialog-content>
    <vg-player (onPlayerReady)="onPlayerReady($event)">
        <vg-buffering vgFor="video"></vg-buffering>

        <vg-controls>
            <vg-scrub-bar>
                <vg-scrub-bar-current-time vgFor="video"></vg-scrub-bar-current-time>
                <vg-scrub-bar-buffering-time vgFor="video"></vg-scrub-bar-buffering-time>
            </vg-scrub-bar>

            <vg-play-pause vgFor="video"></vg-play-pause>
            <vg-time-display vgFor="video" vgProperty="current" vgFormat="mm:ss"></vg-time-display>
            <vg-time-display vgFor="video" vgProperty="total" vgFormat="mm:ss"></vg-time-display>
        </vg-controls>

        <video [vgMedia]="$any(videoPlayer)" #videoPlayer id="video" class="video" [src]="this.src" preload="auto" autoplay crossorigin>
            <source [src]="this.src" [type]="this.type" />
        </video>
    </vg-player>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button
            mat-dialog-close>
        {{ 'Close' | translate}}
    </button>
</mat-dialog-actions>
